import Post from "../post/Post";
import Share from "../share/Share";
import "./Recent.css";
import { useState, useEffect, useContext } from "react";
import axiosInstance from '../../config';
import SocialContext from "../../context/SocialContext";
import { Link } from "react-router-dom";
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import ViewHeadlineOutlinedIcon from '@mui/icons-material/ViewHeadlineOutlined';
import Progress from "../Progress/Progress";

export default function UserPost(props) {
    const { user } = useContext(SocialContext);
    const [posts, setposts] = useState([]);
    const [fetchagain, setfetchagain] = useState(false);
    const [loading, setloading] = useState(false);

    const fetchPosts = async () => {
        try {
            setloading(true);
            let response =  await axiosInstance.get(`/api/posts/profile/${props.user}`);
            setposts(response.data.sort((p1, p2) => {
                return new Date(p2.createdAt) - new Date(p1.createdAt);
            }));
            setloading(false);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchPosts();
    }, [user, props.user, fetchagain])

    return (
        <div className="feed">
            <div className="feedWrapper">
                {(!props.user || props.user === user.username) && <Share />}

                <h2 className="recentH2"><ViewHeadlineOutlinedIcon style={{ 'fontSize': '40px', 'marginRight': '5px' }} />Recent Activities</h2>

                {loading ? <Progress /> : <div className="recent">
                    {posts.length == 0 ? <div>
                        <div className="NopostsClass">
                            <h4><EmojiEmotionsOutlinedIcon style={{ 'fontSize': '34px', 'marginRight': '5px' }} />Sorry</h4>
                            <p>User has not posted anything yet!</p>
                        </div>
                        <Link style={{'textDecoration':'none'}} to={'/'}><button className="btn followBtn" style={{ marginTop: '12px','textDecoration':'none'}}>Go Back</button></Link>
                    </div> : ""}
                </div>}

                {posts.map((p) => (
                    <Post key={p._id} post={p} setfetchagain={setfetchagain} />
                ))}
            </div>
        </div>
    );
}